import VersionGroup from "./VersionGroup";

export default class VersionGroups {

    public static english = new VersionGroup({
        id: 'english',
        name: 'English'
    });

    public static interlinear = new VersionGroup({
        id: 'interlinear',
        name: 'Interlinear'
    });

    public static hebrewCodices = new VersionGroup({
        id: 'hebrewCodices',
        name: 'Hebrew Codices'
    });

    public static greekCodices = new VersionGroup({
        id: 'greekCodices',
        name: 'NT Greek Codices'
    });

    public static lxxCodices = new VersionGroup({
        id: 'lxxCodices',
        name: 'LXX Codices'
    });

    public static correctedCodices = new VersionGroup({
        id: 'correctedCodices',
        name: 'Corrected Codices'
    });

    public static hebrewParsingAndStems = new VersionGroup({
        id: 'hebrewParsingAndStems',
        name: 'Hebrew Parsing & Stems'
    });

    public static greekParsing = new VersionGroup({
        id: 'greekParsing',
        name: 'NT Greek Parsings'
    });

    public static greekStems = new VersionGroup({
        id: 'greekStems',
        name: 'NT Greek Stems'
    });

    public static lxxParsingAndStems = new VersionGroup({
        id: 'lxxParsingAndStems',
        name: 'LXX Parsing & Stems'
    });

    public static international = new VersionGroup({
        id: 'international',
        name: 'International'
    });
}
